import React from "react";
import { Row, Col, Button, Card } from "react-bootstrap";
import useWindowDimensions from "../../utils/useWindowDimensions";
import { Link } from "react-router-dom";

import styles from "./ProposalList.module.css";
import { Form } from "react-bootstrap";

function ProposalList(props) {
  const { height, width } = useWindowDimensions();

  const infos = [
    {
      id: 1,
      title: "ArcadeQuest",
      description: "The online world lacks intimacy, we're solving this using gaming. We found that gamers use YouTube, TikTok and Twitch.",
      actionBtn: "Game Proposal",
      website: "arcadeQuestProposal",
    },
    {
      id: 2,
      title: "Action on Climate Change",
      description: "There are many benefits to taking action on climate change such as improved health,growth in the low-carbon jobs market and reduce inequality.",
      actionBtn: "Climate Proposal",
      website: "individualPropose",

    },
    {
      id: 3,
      title: "DeliveryBizConnect",
      description: "DeliveryBizConnect saves restaurants $18,315.90 per year on pickup & delivery fees with our FREE Pickup & 3.33% delivery fee",
      actionBtn: "Business Proposal",
      website: "deliveryBizConnectProposal",

    },
  ];

  const contentDescription = infos.map((info) => (
    <Form.Group as={Col} md="12" key={info.id}>
      <Card className={styles.cardBody}>
        <Row>
          <Col sm={9}>
            <Card.Body>
              <div className={styles.proposalBody}>
              <h4 className={styles.cardTitle}>{info.title}</h4>
              <Card.Text className={styles.cardBodyText}>
                    {info.description}
              </Card.Text>
              <Link to={`${info.website}`}>
                <Button className={styles.voteButton}>
                  <div className={styles.voteButtonText}>{info.actionBtn}</div>
                </Button>
              </Link>
              </div>
            </Card.Body>
          </Col>
          <Col sm={3}>
            <Link to={`${info.website}`}>
            <Button className={styles.headerButtons}>
              <div className={styles.headerButtonText}>Vote Now</div>
            </Button>
            </Link>
          </Col>
        </Row>
      </Card>
      <br />
    </Form.Group>
  ));

  return (
    <Row className={styles.ContentContainer}>
        <Form.Group as={Col} md="12">
          <h3>{contentDescription}</h3>
        </Form.Group>
    </Row>
  );
}

export default ProposalList;